export const TabId = {
  General: "general",
  CodingGuidelines: "coding-guidelines",
  Git: "git",
  RootFolder: "root-folder",
  PreviewSetup: "preview-setup",
  Secrets: "secrets",
  WarmupSnapshots: "warmup-snapshots",
  PooledPreview: "pooled-preview",
} as const

export type ProjectSettingsTabId = typeof TabId[keyof typeof TabId]

export function isTabId(value: string): value is ProjectSettingsTabId {
  return Object.values(TabId).includes(value as ProjectSettingsTabId)
}
